export default {
  'global#home': 'Home',
  'global#maps': 'Mappe',
  'global#works': 'Opere',
  'global#date_human': 'Do MMMM YYYY',
  'global#layout_error_title': 'Spiacenti, si è verificato un errore',
  'global#layout_error_description':
    "Prova a ricaricare la pagina tra qualche istante e se il problema persiste contatta l'amministratore della piattaforma.",
  'readmore#label': 'Mostra tutto',
  'search#works_total': '<strong>{ total }</strong> Opere',
  'search#works_total_1': '<strong>{ total }</strong> Opera',
  'search#works_total_0': 'Nessuna Opera',
  'search#authors_total': '<strong>{ total }</strong> Autori Antichi',
  'search#authors_total_1': '<strong>{ total }</strong> Autore Antico',
  'search#authors_total_0': 'Nessun Autore Antico',
  'search#books_total': '<strong>{ total }</strong> Libri',
  'search#books_total_1': '<strong>{ total }</strong> Libro',
  'search#books_total_0': 'Nessun Libro',
  'search#witnesses_total': '<strong>{ total }</strong> Testimoni',
  'search#witnesses_total_1': '<strong>{ total }</strong> Testimone',
  'search#witnesses_total_0': 'Nessun Testimone',
  'search#placeholder_query': 'Cerca nei titoli delle Opere',
  'search#placeholder_authors_query': 'Cerca un Autore Antico',
  'search#placeholder_query-content': 'Cerca nelle opere contenute',
  'search#header_authors': 'Autori Antichi',
  'search#header_fonti': 'Fonti Antiche',
  'search#header_keywords': 'Keywords',
  'search#header_works': 'Opere',
  'search#header_libraries': 'Biblioteca',
  'search#header_cities': 'Città',
  'search#header_dates': 'Date',
  'search#facets_title': 'Filtra i risultati',
  'search#filters_title': 'Filtri attivi:',
  'search#sort_title': 'Ordine',
  'search#sort_score': 'Ordine per pertinenza',
  'search#sort_asc': 'Ordine alfabetico (A→Z)',
  'search#sort_desc': 'Ordine alfabetico (Z→A)',
  'search#fallback_text':
    'La tua ricerca non ha dato risultati. Prova a cambiare i parametri oppure a resettare la ricerca cliccando sul pulsante sottostante.',
  'search#fallback_button': 'Resetta la ricerca',
  'search#ko_text':
    'Oops, abbiamo riscontrato un errore nella ricerca. Prova a cambiare i parametri oppure a resettare la ricerca cliccando sul pulsante sottostante.',
  'search#ko_button': 'Resetta la ricerca',
  'search#description_button': 'Info',
  'search#description_link': 'Ok, ho capito',
  'resource#authors': 'di',
  'resource#date': 'pubblicato il',
  'resource#time_to_read': 'lettura di',
  'resource#metadata': 'Metadati',
  'resource#metadata_size': 'Dimensioni',
  'search#header_genres': 'Genere',
  'search#header_language': 'Lingua',
  'search#date': 'data',
  'search#bibliographies_total':
    '<strong>{ total }</strong> riferimenti bibliografici',
  'search#bibliographies_total_1':
    '<strong>{ total }</strong> riferimento bibliografico',
  'search#bibliographies_total_0': 'Nessun riferimento bibliografico',
  'search#placeholder_authors': 'Cerca tra gli autori antichi',
  'search#placeholder_fonti': 'Cerca tra le Opere degli autori antichi',
  'search#title_bibliographies': 'Bibliografia',
  'search#biographies_total': '<strong>{ total }</strong> vite antiche',
  'search#biographies_total_1': '<strong>{ total }</strong> vita antica',
  'search#biographies_total_0': 'Nessuna vita antica',
  'search#title_biographies': 'Vite antiche',
  'search#iconographies_total': '<strong>{ total }</strong> iconografie',
  'search#iconographies_total_1': '<strong>{ total }</strong> icongrafia',
  'search#iconographies_total_0': 'Nessuna iconografia',
  'search#title_iconographies': 'Vite antiche',
  'search#tools_total': '<strong>{ total }</strong> materiali e strumenti',
  'search#tools_total_1': '<strong>{ total }</strong> materiale e strumento',
  'search#tools_total_0': 'Nessun materiale e strumento',
  'search#title_tools': 'Materiali e strumenti',
  'resource#collection_bibliography': 'Bibliografia',
  'tabs#ancient_author_occurrences': 'Occorrenze nel corpus leopardiano',
  'tabs#ancient_author_works': "Opere dell'autore",
  'tabs#ancient_author_scheda': "Scheda autore",
  'global#facet_empty_text': 'Nessun elemento disponibile',
  'search#resultsamount': 'Risultati per pagina',
  'readmore#more': 'Leggi tutto',
  'readmore#less': 'Leggi meno',
  'resource#collection_bibliography_ancient_author': "Edizioni utilizzate per l'autore",
  'resource#collection_bibliography_mediator': "Mediatori",
  'resource#collection_bibliography_critical': 'Bibliografia critica',
  'advancedsearch#works_total': '<strong>{ total }</strong> Risultati',
  'advancedsearch#works_total_1': '<strong>{ total }</strong> Risultato',
  'advancedsearch#works_total_0': 'Nessun Risultato',
  'advancedsearch#search_in_title': 'Cerca in:',
  'advancedsearch#label_title': 'Titolo',
  'advancedsearch#label_work_title': "Seleziona un'opera",
  'advancedsearch#label_work_title_info':
    'Seleziona il titolo dell’opera in cui desideri effettuare la ricerca. Non indicare alcuna voce se intendi cercare in tutte le opere',
  'advancedsearch#label_resource_type': 'Tipo di risorsa',
  'advancedsearch#label_text': 'Cerca nei testi',
  'advancedsearch#label_search_title': 'Ricerca nei testi',
  'advancedsearch#label_content': 'Contenuti',
  'advancedsearch#intro':
    'In questa sezione è possibile interrogare, in modo semplice o incrociato, i dati presenti nel portale.\n“Cerca nel portale” permette di estrarre, attraverso una ricerca generale, risultati dalle varie sezioni che possono essere interrogate singolarmente o in modo simultaneo.\n“Cerca nelle opere” consente una ricerca testuale, per lemma e/o per voce di autorità, all’interno delle opere di Leopardi.',
  'advancedsearch#search_portal': 'Cerca nel portale',
  'advancedsearch#fulltext_text': 'Cerca nel portale (in tutti i campi)',
  'advancedsearch#fulltext_info':
    'Cerca un termine in tutte le sezioni del portale.',
  'advancedsearch#section_info':
    'Indica la sezione o le sezioni in cui desideri effettuare la ricerca',
  'advancedsearch#label_textual': 'Ricerca testuale',
  'advancedsearch#library_text': 'Biblioteca',
  'advancedsearch#label_signature': 'Segnatura',
  'advancedsearch#section_global': 'Cerca nel portale',
  'advancedsearch#label_type': 'cerca in:',
  'advancedsearch#advanced_search': 'Ricerca avanzata',
  'advancedsearch#section_textual': 'Cerca nelle opere',
  'advancedsearch#label_manuscript_content': 'Contenuti dei manoscritti',
  'advancedsearch#text_info':
    'Effettuando un’interrogazione per lemma, puoi ricorrere a caratteri speciali per affinarla: * corrisponde a un numero qualsiasi di caratteri ed è possibile usarlo in qualsiasi posizione in una stringa di caratteri; ? corrisponde a un singolo carattere alfabetico in una posizione specifica di una stringa.<br>Inoltre, mettere tra “virgolette” più termini permetterà di trovare tutti i risultati con corrispondenza esatta; OR permette di cercare questo O quello: la ricerca restituirà i risultati relativi ai due termini o ad entrambi; AND permette di cercare questo E quello: l’operatore restituirà solo i risultati relativi a entrambi i termini.<br>Una volta avviata la ricerca, selezionando i singoli risultati ottenuti verrai indirizzato nella sezione dell’opera in cui l’occorrenza è presente; per raggiungere l’esatta porzione di testo interessata puoi poi scorrere il testo o, in alternativa, effettuare una ricerca veloce attraverso il comando CTRL+F',
  'advancedsearch#include_authority': 'Voci di autorità',
  'advancedsearch#text_title': 'cerca per lemma',
  'advancedsearch#querytext_authority_info':
    'Permette di interrogare il vocabolario di Nomi e Luoghi presente nelle opere di Leopardi. Ad es. cercando “Roma” la ricerca non restituirà unicamente il lemma digitato ma anche tutti i casi in cui l’autore nomina un luogo identificato come “Roma” dal curatore dell’edizione elettronica del testo',
  'advancedsearch#querytext_authority_label': 'includi voce di autorità',
  'advancedsearch#label_text_distance': 'Ricerca per prossimità',
  'advancedsearch#label_name': 'Persone',
  'advancedsearch#label_place': 'Luoghi',
  'advancedsearch#label_autorithy_name': 'Persone (voce di autorità)',
  'advancedsearch#label_autorithy_place': 'Luoghi (voce di autorità)',
  'advancedsearch#label_name_info':
    'Cerca una persona selezionando la voce di autorità corrispondente',
  'advancedsearch#label_place_info':
    'Cerca un luogo selezionando la voce di autorità corrispondente',
  'advancedsearch#label_text_bibl': 'Cerca nelle fonti',
  'advancedsearch#label_bibl': 'Fonti',
  'advancedsearch#label_witnesses': 'Testimoni',
  'advancedsearch#label_works': 'Schede Opere',
  'advancedsearch#label_library': 'Biblioteca',
  'advancedsearch#label_ancient_author': "Autori Antichi",
  'advancedsearch#label_timeline': 'Cronologia',
  'advancedsearch#label_work': 'Opere',
  'advancedsearch#label_biographies': 'Vite antiche',
  'advancedsearch#label_itineraries': 'Percorsi',
  'advancedsearch#label_type_text': 'Cerca nei testi dalle sezioni:',
  'advancedsearch#label_bibliography': 'Bibliografia',
  'advancedsearch#label_tools': 'Strumenti',
  'advancedsearch#label_source': 'fonte',
  'advancedsearch#distance_value': 'Parole interposte',
  'advancedsearch#distance_text': 'Testo',
  'advancedsearch#label_query_work_fulltext': 'Opere',
  'advancedsearch#fulltext_work_text': 'Cerca nella scheda opera',
  'advancedsearch#label_bibl_info':
    'Seleziona il titolo di una fonte per estrarre tutti i passi che Leopardi trae da questa e cita nelle sue opere.',
  'advancedsearch#highlights_title': 'Risultati',
  'advancedsearch#reset': 'Pulisci campi',
  'advancedsearch#submit': 'Cerca',
  'advancedsearch#title': "Ricerca"
};
